// extracted by mini-css-extract-plugin
export default {"filterItem":"TranslationsFilters_filterItem__il9oJ","filters":"TranslationsFilters_filters__2+mCk","filterLabel":"TranslationsFilters_filterLabel__+Xb+2"};